(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('CompanyCustom', CompanyCustom);

    CompanyCustom.$inject = ['$resource', '__config', 'ENV'];

    function CompanyCustom($resource, __config, ENV) {


        var findCompanyByQuery = function (query) {

            var resourceUrl = ENV.API_BASE_URL + 'api/find-company-by-query?query=' + query;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var findCompaniesForAgentRequest = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/find-companies-for-agent-request';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        }

        var getCurrentCompany = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/get-current-company';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        }

        var findCompanyByKeyURL = function (keyUrl) {
            var resourceUrl = ENV.API_BASE_URL + 'api/find-company-by-key-url?keyUrl=' + keyUrl;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        }

        var getCompaniesByParentId = function (parentId) {
            var resourceUrl = ENV.API_BASE_URL + 'api/get-companies-by-parent-id?parentId=' + parentId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        }
        var changeCurrentCompany = function (keyurl) {
            var resourceUrl = ENV.API_BASE_URL + 'api/change-current-company/' + keyurl;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        }


        var companyCustomSettingField = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/company-custom-setting-field';
            return $resource(resourceUrl, {}, {}
            );
        }


        var getCompanyActivityTypes = function () {
            var activityTypes = [];

            if (__config.appMode == 'reserve') {
                activityTypes.push('PSYCHOLOGIST');
                activityTypes.push('BUSINESS_CONSULTING');
                activityTypes.push('MEN_SALON');
                activityTypes.push('WOMEN_SALON');
                activityTypes.push('DOCTOR');
                activityTypes.push('SPA');
                activityTypes.push('WORK_SPACE');
                activityTypes.push('ATELIER');
                activityTypes.push('IMMIGRATION');
                activityTypes.push('COACHING');
                activityTypes.push('SCAPE_ROOM');
                activityTypes.push('BEAUTY_CLINIC');
                activityTypes.push('CAR_SERVICE');
                activityTypes.push('ENTERPRISE');
                activityTypes.push('ACUPUNCTURE');
                activityTypes.push('HOBBY');
                activityTypes.push('BEAUTY');
                activityTypes.push('TRAVEL');
                activityTypes.push('HEALTH');
                activityTypes.push('SPORT');
                activityTypes.push('EDUCATION');
                activityTypes.push('OTHER');
            }

            if (__config.appMode == 'event') {
                activityTypes.push('INSTITUTE');
                activityTypes.push('SCHOOL');
                activityTypes.push('UNIVERSITY');
                activityTypes.push('BUSINESS_CONSULTING');
                activityTypes.push('PSYCHOLOGIST');
                activityTypes.push('EDUCATION');
                activityTypes.push('DOCTOR');
                activityTypes.push('HOBBY');
                activityTypes.push('HEALTH');
                activityTypes.push('DIGITAL_MARKETING_AGENCY');
                activityTypes.push('OTHER');
            }

            return activityTypes;
        }


        var updateCompanyFieldByAdmin = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/update-company-field-by-admin';
            return $resource(resourceUrl, {}, {}
            );
        }

        var isCurrentCompanyListedInAnyMarketPlaces = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/is-current-company-listed-in-any-marketplaces';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var deActiveCompanyByKeyURL = function (keyUrl) {
            var resourceUrl = ENV.API_BASE_URL + 'api/de-active-company-by-key-url?keyUrl=' + keyUrl;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        }


        var getCompanyWebSiteAddressClearCache = function (then) {
            this.getCurrentCompany().query().$promise.then(function (com) {
                var site = com.keyUrl;
                site = site + '.' + __config.domain;

                if (com.hasDedicatedDomain && com.domain) {
                    site = com.domain;
                }
                site = "https://" + site + "/#/home/true";
                if (then)
                    then(site);
            })
        }

        var getCurrentCompanyOnBoardingMode = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/get-current-company-on-boarding-mode';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        }

        var getCurrentCompanyWizardSteps = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/get-current-company-wizard-steps';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        }

        var setCompanyWizardStepsDone = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/company-wizard-steps-done';
            return $resource(resourceUrl, {}, {}
            );
        }

        var downgradeVersion = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/downgrade-version';
            return $resource(resourceUrl, {}, {}
            );
        }

        var upgradeVersion = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/upgrade-version';
            return $resource(resourceUrl, {}, {}
            );
        }


        var skipCompanyWizardSteps = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/skip-company-wizard-steps';
            return $resource(resourceUrl, {}, {}
            );
        }

        return {
            findCompanyByQuery: findCompanyByQuery,
            findCompaniesForAgentRequest: findCompaniesForAgentRequest,
            getCurrentCompany: getCurrentCompany,
            findCompanyByKeyURL: findCompanyByKeyURL,
            getCompaniesByParentId: getCompaniesByParentId,
            changeCurrentCompany: changeCurrentCompany,
            companyCustomSettingField: companyCustomSettingField,
            getCompanyActivityTypes: getCompanyActivityTypes,
            updateCompanyFieldByAdmin: updateCompanyFieldByAdmin,
            isCurrentCompanyListedInAnyMarketPlaces: isCurrentCompanyListedInAnyMarketPlaces,
            deActiveCompanyByKeyURL: deActiveCompanyByKeyURL,
            getCompanyWebSiteAddressClearCache: getCompanyWebSiteAddressClearCache,
            getCurrentCompanyOnBoardingMode: getCurrentCompanyOnBoardingMode,
            getCurrentCompanyWizardSteps: getCurrentCompanyWizardSteps,
            setCompanyWizardStepsDone: setCompanyWizardStepsDone,
            downgradeVersion: downgradeVersion,
            upgradeVersion: upgradeVersion,
            skipCompanyWizardSteps: skipCompanyWizardSteps

        };
    }
})();
